import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { BlockMath } from "react-katex";
import firebase from "firebase/compat/app";
import "katex/dist/katex.min.css";

const Chapter7_5 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist eine zentrale Aufgabe der Richtlinien im ISMS?",
      options: [
        {
          value: "A",
          label:
            "Die Standardisierung von Prozessen und Maßnahmen zur Informationssicherheit.",
        },
        {
          value: "B",
          label:
            "Die automatische Beseitigung aller identifizierten Schwachstellen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie unterstützt ein ISMS die Einhaltung von Compliance-Vorgaben?",
      options: [
        {
          value: "A",
          label:
            "Durch die Dokumentation und Überwachung von Sicherheitsmaßnahmen.",
        },
        {
          value: "B",
          label:
            "Durch die Automatisierung aller regulatorischen Anforderungen.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_5.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "7_5",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("7_5"),
            });
          console.log("Dokument aktualisiert mit Kapitel 7_5.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "7_5",
              completedChapters: ["7_5"],
            });
          console.log("Dokument erstellt mit Kapitel 7_5");
        }

        navigate("/8_1"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  7. IT-Risikomanagement
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Risikosteuerung
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 7: IT-Risikomanagement</h3>
          <h2 className="text-center pb-5">Ausgewählte Instrumente der IT-Risikosteuerung </h2>
          <img
            src="/images/risikoakzeptanz.png"
            alt="Risikoakzeptanz"
            style={{ position: "relative", maxWidth: "20%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-4">Ausgewählte Instrumente der IT-Risikosteuerung </h2>
          <p className="col-lg-11 mx-auto">
            Im Rahmen der Risikosteuerung werden die
            geplanten Maßnahmen nicht nur implementiert, sondern auch überwacht und
            angepasst, um sie kontinuierlich effektiv zu bleiben. Nun sind in der Risikosteuerung operative Schritte erforderlich, um die zuvor festgelegten Strategien
            wie Vermeidung, Minderung, Übertragung oder Akzeptanz in die Praxis
            umzusetzen.
          </p>

 <h3 className="p-5">
              {" "}
              KI verändert die Risikoakzeptanz und Kosten-Nutzen-Analyse in der
              Cybersecurity
            </h3>
            <p className="col-lg-11 mx-auto">
              Dank <strong>Machine Learning</strong> kann KI große Datenmengen
              in Echtzeit analysieren und potenzielle Bedrohungen vorhersagen. Machine Learning ermöglicht es, Muster in Daten zu erkennen, die auf bevorstehende Angriffe oder Schwachstellen hinweisen könnten. Diese Fähigkeit ermöglicht eine präzisere Risikoeinschätzung und hilft Unternehmen
              ihre <strong>Risikoakzeptanz</strong> dynamisch anzupassen.{" "}
              <br />
              <br />
              Zudem erlaubt KI{" "}
              <strong>automatisierte Kosten-Nutzen-Analysen</strong>, die
              laufend aktualisiert werden, um Echtzeit-Empfehlungen für die
              effektivsten und kostengünstigsten Sicherheitsmaßnahmen zu geben.
              Die <strong>Entscheidungsunterstützung</strong> wird durch
              automatisch generierte, datenbasierte Empfehlungen verbessert, die
              die Ressourcenverteilung optimieren und die Effizienz steigern.
              Über <strong>Feedback-Schleifen</strong> lernt die KI
              kontinuierlich dazu und passt sich an neue Bedrohungen an, was die
              Qualität der Risiko- und Kosten-Nutzen-Analyse langfristig
              verbessert. <br />
              <br />
              Schließlich ermöglicht KI eine{" "}
              <strong>schnellere und genauere Reaktion auf Bedrohungen</strong>,
              da sie automatisch Abwehrmaßnahmen einleiten kann. 
            </p>
</div>


 <div className="grey-section">
        <div className="container p-5">
          <h3 className="p-5">Information Security Management System</h3>
          <p className="col-lg-11 mx-auto">
            <br />
            <br />
            Ein hilfreiches Werkzeug der Risikosteuerung im Cybersecurity-Management
            ist das{" "}
            <strong>Information Security Management System (ISMS). </strong> Es
            bietet einen ganzheitlichen Ansatz, um alle Aktivitäten und Prozesse
            der Risikosteuerung zu unterstützen und zu dokumentieren.
            <br />
            <br />
            Es verbindet Richtlinien, Prozesse, Technologien und Anwender, um:
          </p>
          <p className="col-lg-6 text-start mx-auto">
            <ul>
              <li>Risiken effektiv zu kontrollieren,</li>
              <li>Maßnahmen zur Risikominderung umzusetzen und</li>
              <li>
                die Wirksamkeit dieser Maßnahmen kontinuierlich zu überprüfen.
              </li>
            </ul>
          </p>

          <p className="col-lg-11 mx-auto">
            Das ISMS spielt auch eine entscheidende Rolle dabei, regulatorische
            Anforderungen wie NIS2, DORA oder ISO/IEC 27001 zu erfüllen. Das
            ISMS dokumentiert, wie Sicherheitsmaßnahmen eingeführt, überwacht
            und verbessert werden. Diese Dokumentation dient als Nachweis für
            interne und externe Audits. Daneben können Vorfälle systematisch
            erfasst und Berichte erstellt werden, die für die Einhaltung
            gesetzlicher Vorgaben erforderlich sind.
          </p>
        </div>
      </div>

      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h2 className="p-5">
              Wie ein ISMS die Risikosteuerung unterstützt
            </h2>
            <p className="col-lg-11 mx-auto">
              <strong>Organisation und Umsetzung: </strong> <br />
              <br />
              Das ISMS dient als zentrale Plattform, um alle Maßnahmen der
              Risikosteuerung zu koordinieren. Dazu gehören:
            </p>

            <p className="col-lg-6 text-start mx-auto">
              <ul>
                <li>Definition klarer Verantwortlichkeiten,</li>
                <li>Zuweisung von Ressourcen und Zeitplänen und</li>
                <li>Dokumentation der Umsetzung.</li>
              </ul>
            </p>
            <p className="col-lg-11 mx-auto">
              Beispielsweise können Sicherheitsrichtlinien für {" "}
              <Link to="/2_3" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Passwortrichtlinien{" "}
              </Link>{" "}
              oder die{" "}
              <Link to="/2_3#mfa" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Multi-Faktor-Authentifizierung (MFA)
              </Link>{" "}
              systematisch erstellt und allen Mitarbeitenden entsprechend kommuniziert
              werden.
              <br />
              <br />
              <br />
              <strong>Überwachung und Messung:</strong> <br />
              <br />
              Ein ISMS ermöglicht die Einführung von{" "}
              <strong>
                Key Performance Indicators (KPIs) und Key Risk Indicators
                (KRIs),{" "}
              </strong>{" "}
              um die Effektivität und den Status der Maßnahmen zu überwachen.
              KPIs messen beispielsweise die Anzahl der geschlossenen
              Schwachstellen in einem definierten Zeitraum, während KRIs als
              Frühwarnsystem dienen, indem sie potenziell steigende Risiken wie
              eine Zunahme von{" "}
              <Link to="/2_4" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Phishing,{" "}
              </Link>
              -Vorfällen anzeigen.
              <br />
              <br />
              <br />
              <strong>Kontinuierliche Verbesserung:</strong>
              <br />
              <br />
              Ein ISMS basiert auf dem{" "}
              <span
                data-tooltip-id="tooltip-PDCA"
                data-tooltip-content="Der PDCA-Zyklus (Plan-Do-Check-Act) ist ein kontinuierlicher Verbesserungsprozess, der in vier Schritten abläuft: Planen, Umsetzen, Überprüfen und Anpassen. Er wird genutzt, um Prozesse oder Maßnahmen systematisch zu optimieren, indem Ergebnisse regelmäßig geprüft und auf Basis der Erkenntnisse verbessert werden."
                className="custom-tooltip-trigger"
              >
                PDCA-Zyklus (Plan-Do-Check-Act),{" "}
              </span>{" "}
              der sicherstellt, dass Sicherheitsmaßnahmen regelmäßig überprüft
              und an neue Bedrohungen oder organisatorische Anforderungen
              angepasst werden. Diese schrittweise/iterative Herangehensweise
              schafft die Grundlage für langfristige Sicherheit und
              Anpassungsfähigkeit.
            </p>
            <ReactTooltip
              id="tooltip-PDCA"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>
        </div>
        

      <div className="gelb-section">
        <div className="container p-5">
          <div className="p-5 ">
            <h2 className="p-5">KPIs und KRIs in der Risikosteuerung</h2>
            <p className="col-lg-11 mx-auto">
              Ein zentraler Bestandteil der Risikosteuerung ist die Überwachung
              und Bewertung der eingeführten Maßnahmen. Hierbei spielen{" "}
              <strong>Key Performance Indicators (KPIs) </strong> und{" "}
              <strong>Key Risk Indicators (KRIs) </strong> eine entscheidende
              Rolle.
              <br />
              <br />
              KPIs helfen, den Fortschritt und die Effektivität von
              Sicherheitsmaßnahmen zu bewerten. Sie liefern messbare Daten, wie z. B. 
              die durchschnittliche Zeit zur Behebung einer Schwachstelle oder
              den Anteil der Nutzer, die konforme Passwörter verwenden. Diese
              Kennzahlen machen es möglich, die Effizienz der Maßnahmen
              kontinuierlich im Blick zu behalten und bei Bedarf Anpassungen
              vorzunehmen.
              <br />
              <br />
              KRIs konzentrieren sich auf die Identifikation potenzieller
              Risiken. Sie geben Einblick in Entwicklungen, die auf ein
              steigendes Risiko hinweisen, wie die Zunahme von
              Phishing-Angriffen oder eine wachsende Zahl ungepatchter
              Schwachstellen. Die regelmäßige Analyse dieser Indikatoren
              ermöglicht es, frühzeitig Maßnahmen zu ergreifen, bevor sich
              Risiken verschärfen.
              <br />
              <br />
              Einfach erklärt: KPIs des Risikomanagements messen, wie{" "}
              <strong>gut etwas funktioniert. </strong> Zum Beispiel: "Wie
              schnell beheben wir Probleme?"
              <br />
              KRIs zeigen, <strong>wie groß ein Risiko ist </strong> oder ob es
              wächst. Zum Beispiel: "Wie oft gibt es verdächtige Aktivitäten?"
              <br /> <br />
            </p>

            <table
              class="table table-light
                 table-striped-columns  mb-5 fs-5"
            >
              <thead>
                <tr>
                  <th scope="col">Begriff</th>
                  <th scope="col">Definition</th>
                  <th scope="col">Beispiel</th>
                  <th scope="col">Zahlenwert</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    KPI <br />
                    <small>(Key Performance Indicator)</small>
                  </th>
                  <td>
                    <strong>Leistungsindikator: </strong> Misst die Effektivität
                    von Maßnahmen und Prozessen.
                  </td>
                  <td>Wie schnell werden Sicherheitslücken geschlossen?</td>
                  <td>
                    Durchschnittliche Zeit zur Behebung:{" "}
                    <strong>10 Tage </strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    KRI <br /> <small>(Key Risk Indicator)</small>{" "}
                  </th>
                  <td>
                    <strong>Risikoindikator: </strong> Zeigt an, ob Risiken
                    zunehmen oder neue Risiken entstehen.
                  </td>
                  <td>Wie viele Phishing-Angriffe gibt es pro Woche?</td>
                  <td>
                    Mehr als <strong>50 Phishing-Mails = Alarmwert </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 ">
 <h2 className="p-5">ROSI (Return on Security Investment)</h2>
<p className="col-lg-11 mx-auto">
  Während KPIs die Leistung von Sicherheitsmaßnahmen messen und KRIs auf
  potenzielle Risiken hinweisen, hilft ROSI (Return on Security Investment),
  die <strong>Wirtschaftlichkeit</strong> solcher Maßnahmen zu bewerten.
  ROSI zeigt, ob die Investitionen in Sicherheitsmaßnahmen in einem
  sinnvollen Verhältnis zu den <strong>vermiedenen erwarteten Schäden</strong>
  stehen. Es handelt sich also um eine wirtschaftliche Kennzahl, die
  Unternehmen dabei unterstützt, Sicherheitsmaßnahmen finanziell
  einzuordnen.

  <br />
  <br />

  Die Berechnung von ROSI erfolgt mit der folgenden Formel:

  <br />
  <br />

  <BlockMath>
    {
      "ROSI(\\%) = \\frac{\\text{Einsparungen} - \\text{Kosten der Maßnahme}}{\\text{Kosten der Maßnahme}} \\cdot 100"
    }
  </BlockMath>

  <br />
  <br />

  Dabei stehen die <strong>Einsparungen</strong> für den
  <strong> vermiedenen erwarteten Schaden</strong>, also für den Schaden,
  der durch die Sicherheitsmaßnahme voraussichtlich verhindert wird.

  <br />
  <br />

  <strong>Beispiel:</strong>
  <br />
  <br />
  Ein Unternehmen investiert <strong>20.000 €</strong> in eine neue Firewall,
  um Cyberangriffe zu verhindern.
  <br />
  Der vermiedene erwartete Schaden beträgt <strong>50.000 €</strong>.
  <br />
  Die Berechnung lautet:

  <br />
  <br />

  <BlockMath>
    {
      "ROSI = \\frac{50\\,000 - 20\\,000}{20\\,000} \\cdot 100 = 150\\%"
    }
  </BlockMath>

  <br />
  <br />

  Ein ROSI von <strong>150 %</strong> bedeutet, dass der Netto-Nutzen der
  Maßnahme 150 % der Investitionskosten beträgt.
  Anders gesagt: Der vermiedene Schaden ist deutlich höher als die Kosten
  der Maßnahme.

  <br />
  <br />

  Dabei gilt:
  <br />
  <strong>ROSI {">"} 0 %</strong> bedeutet, dass der vermiedene erwartete Schaden
  die Kosten übersteigt.
  <br />
  <strong>ROSI = 0 %</strong> bedeutet, dass die Maßnahme wirtschaftlich genau
  auf der Grenze liegt.
  <br />
  <strong>ROSI {"<"} 0 %</strong> bedeutet, dass die Kosten höher sind als der
  erwartete vermiedene Schaden.

 
  <br />
  <br />

  ROSI ergänzt KPIs und KRIs damit um die finanzielle Perspektive:
  Während KPIs die Leistung messen und KRIs auf Risiken hinweisen,
  bewertet ROSI die wirtschaftliche Tragfähigkeit einer Maßnahme.
  Unternehmen können so besser priorisieren und ihre Ressourcen gezielter
  einsetzen.

  <br />
  <br />

  Wichtig ist jedoch: Ein niedriger oder negativer ROSI bedeutet nicht
  automatisch, dass eine Maßnahme überflüssig ist. Manche Maßnahmen sind
  trotz geringer wirtschaftlicher Rendite notwendig, etwa aus rechtlichen,
  regulatorischen oder organisatorischen Gründen.
</p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container pt-5">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              {" "}
              Praxisbeispiel: ISMS in der Risikosteuerung
            </h3>
            <p className="col-lg-10 text-start mx-auto">
              Szenario: Ein Unternehmen stellt fest, dass unsichere Passwörter
              ein erhebliches Risiko darstellen, da sie potenziell Angreifern
              den Zugang zu sensiblen Systemen ermöglichen. Die Analyse zeigt,
              dass viele Mitarbeitende schwache Passwörter verwenden oder diese
              mehrfach nutzen.
              <br />
              <br />
              <br />
              <strong>Planung:</strong>
              <br /> Um das identifizierte Risiko zu minimieren, entwickelt das
              Unternehmen eine Passwortrichtlinie, die folgende Maßnahmen
              vorschreibt:
              <ul>
                <li>
                  Verwendung starker,{" "}
                  <Link to="/2_3" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    komplexer Passwörter{" "}
                  </Link>{" "}
                  (z. B. Mindestlänge, Kombination aus Buchstaben, Zahlen und
                  Sonderzeichen).
                </li>
                <li>Regelmäßige Passwortwechsel.</li>
                <li>
                  Einführung einer Multi-Faktor-Authentifizierung (MFA), um den
                  Schutz zusätzlich zu erhöhen. Die Passwortrichtlinie wird
                  dokumentiert und an alle Mitarbeitenden kommuniziert, um
                  Transparenz und Akzeptanz zu fördern.
                </li>
              </ul>
              <br />
              <br />
              <strong>Umsetzung:</strong>
              <br />
              Die technischen Anforderungen werden durch die Integration eines
              zentralen Identitätsmanagementsystems (
              <Link to="/1_4#iam" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                IAM
              </Link>{" "}
              ) erfüllt. Das IAM ermöglicht:
              <ul>
                <li>Eine einheitliche Durchsetzung der Passwortrichtlinie.</li>
                <li>
                  Die Implementierung von MFA in allen sensiblen Anwendungen.
                </li>
                <li>
                  Automatische Überprüfung der Passwortstärke bei jeder
                  Erstellung oder Änderung. Die IT-Abteilung führt Schulungen
                  durch, um die Mitarbeitenden mit der neuen Richtlinie und den
                  technischen Änderungen vertraut zu machen.
                </li>
              </ul>
              <br />
              <br />
              <strong>Überwachung:</strong> <br />
              Nach der Umsetzung wird die Einhaltung der Passwortrichtlinie
              kontinuierlich überwacht. Ein Dashboard im IAM-System zeigt:
              <ul>
                <li>
                  Den Anteil der Nutzer, die konforme Passwörter verwenden
                  (KPI).
                </li>
                <li>
                  Die Anzahl der Verstöße gegen die Richtlinie, z. B. mehrfach
                  verwendete oder schwache Passwörter (KRI). Diese Daten helfen
                  der IT-Abteilung, die Effektivität der Maßnahmen zu bewerten
                  und potenzielle Schwachstellen frühzeitig zu identifizieren.
                </li>
              </ul>
              <br />
              <br />
              <strong>Verbesserung:</strong>
              <br />
              Ein internes Audit deckt auf, dass inaktive Konten, die nicht
              automatisch gesperrt werden, ein weiteres Sicherheitsrisiko
              darstellen. Basierend auf diesen Erkenntnissen wird die
              Passwortrichtlinie erweitert, um:
              <ul>
                <li>
                  alle inaktiven Konten nach einer festgelegten Zeitspanne
                  automatisch zu deaktivieren.
                </li>
                <li>
                  regelmäßige Überprüfungen der Kontenaktivität einzuführen.
                  Zusätzlich wird die Schulung der Mitarbeitenden angepasst, um
                  das Bewusstsein für die Bedeutung sicherer Passwörter weiter
                  zu stärken.
                </li>
              </ul>
            </p>
          </div>
        </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter7_5;
